var _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgParking = function SvgParking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("path", {
    id: "Union_159",
    "data-name": "Union 159",
    d: "M13.3,11.65V.857H.7V11.65a.35.35,0,1,1-.7,0V.35A.35.35,0,0,1,.35,0L.387,0,.428,0H13.571l.041,0,.037,0A.35.35,0,0,1,14,.35v11.3a.35.35,0,1,1-.7,0ZM9.1,11.3V10.285H4.9V11.3a.7.7,0,1,1-1.4,0V10.194A2,2,0,0,1,2.1,8.285V8a1.994,1.994,0,0,1,.527-1.353.51.51,0,0,1,.045-.261l1.75-3.712a.366.366,0,0,1,.214-.2A.429.429,0,0,1,4.979,2.3H9.022a.427.427,0,0,1,.342.17.368.368,0,0,1,.215.2l1.75,3.712a.5.5,0,0,1,.045.26A1.994,1.994,0,0,1,11.9,8v.285a2,2,0,0,1-1.4,1.908V11.3a.7.7,0,0,1-1.4,0ZM3.636,6.053A2,2,0,0,1,4.1,6H9.9a2,2,0,0,1,.463.054L9,3.162H5Z",
    fill: "#fff"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgParking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Parking.c1bddab4.svg";
export { ForwardRef as ReactComponent };